import React from 'react';
import { cn } from '../lib/utils';
import { Card, CardContent } from './ui/card';
import IconBadge from './IconBadge';
import EditableText from './EditableText';

/** Feature / benefit card with IconBadge — consistent hover glow. */
const FeatureCard = ({
  icon: Icon,
  title,
  titleKey,
  description,
  descriptionKey,
  variant = 'purple',
  size = 'md',
  className,
  centered = true,
}) => (
  <Card
    className={cn(
      'h-full border-slate-200/90 bg-white shadow-sm transition-colors hover:border-[rgba(58,0,224,0.22)] group',
      centered && 'text-center',
      className
    )}
  >
    <CardContent className={cn('pt-7 pb-7', !centered && 'pt-6')}>
      <IconBadge
        icon={Icon}
        variant={variant}
        size={size}
        className={cn('mb-4', centered && 'mx-auto')}
      />
      {titleKey ? (
        <EditableText
          editKey={titleKey}
          defaultValue={title}
          as="h3"
          className="text-slate-900 font-semibold text-lg mb-2"
        />
      ) : (
        <h3 className="text-slate-900 font-semibold text-lg mb-2">{title}</h3>
      )}
      {descriptionKey ? (
        <EditableText
          editKey={descriptionKey}
          defaultValue={description}
          as="p"
          multiline
          className="text-slate-600 text-sm leading-relaxed"
        />
      ) : (
        <p className="text-slate-600 text-sm leading-relaxed">{description}</p>
      )}
    </CardContent>
  </Card>
);

export default FeatureCard;
